import { XIcon } from '@phosphor-icons/react';
import { Button } from '@shadcn/components/button';
import { TabsTrigger } from '@shadcn/components/tabs';
import styled from 'styled-components';

export const ContentPanelContainer = styled.div<{ $fullHeight?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - ${(props) => (props.$fullHeight ? '0px' : '72px')});
  overflow: hidden;
`;

export const ContentPanelControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  line-height: 14px;
  vertical-align: middle;
`;

export const ContentPanelCloseButton = ({
  onClick,
}: {
  onClick: () => void;
}) => {
  return (
    <Button variant="ghost" size="sm" className="mr-[-8px]" onClick={onClick}>
      <XIcon size={14} />
    </Button>
  );
};

export const ContentPanelTabsTrigger = styled(TabsTrigger)<{
  $withButtons?: boolean;
}>`
  position: relative;

  &[data-state='inactive']::after {
    display: none;
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: ${(props) => (props.$withButtons ? '-13px' : '-9px')};
    height: 2px;
    background-color: black;
    width: 100%;
  }
`;

export const ContentPanelHeader = styled.div`
  position: relative;
  display: flex;
  align-items: last baseline;
  justify-content: space-between;
  height: 57px;
  padding: 12px 24px;
  border-bottom: 1px solid hsl(var(--border));
`;

export const ContentPanelTitle = styled.span`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 500;
`;

export const ContentPanelBody = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  min-height: 0;

  /* Make the tabs container fill the space */
  & > .content-panel-child {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }
`;

export const ContentPanelLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  transition: flex 0.2s ease-in-out;

  /* Make the tabs container fill the space */
  & > div {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }
`;

export const ContentPanelRight = styled.div`
  width: 400px;
  flex-shrink: 0;
  border-left: 1px solid hsl(var(--border));
  display: flex;
  flex-direction: column;
  transition:
    width 0.2s ease-in-out,
    margin 0.2s ease-in-out;
  position: relative;

  &.collapsed {
    width: 0;
    margin: 0;
    border-left: none;
  }

  /* Make the tabs container fill the space */
  & > div {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }
`;

export const ContentPanelCollapseButton = styled.div<{
  $withButtons?: boolean;
  $isCollapsed: boolean;
}>`
  position: absolute;
  top: ${(props) => (props.$withButtons ? '8px' : '12px')};
  left: ${(props) => (props.$isCollapsed ? '-132px' : '12px')};
  z-index: 10;

  transition: left 0.2s ease-in-out;
`;
